export default {
  'Resolution': 'Auflösung',
  'Frame rate': 'Bildrate',
  'The higher the frame rate, the smoother the animation': 'Je höher die Bildrate, desto flüssiger die Animation.',
}